import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import Companies from './containers/Companies/index.ts';
import Users from './containers/Users/index.ts';
import WebsiteGroups from './containers/WebsiteGroups/index.ts';

const Administration = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),

  Users,
  Companies,
  WebsiteGroups,

  BatchLayout: lazy(() => import('./containers/Batch/components/BatchLayout.tsx')),

  JobList: lazy(() => import('./containers/Batch/components/JobList.tsx')),
  BatchK8s: lazyNamed(() => import('./containers/BatchK8s/index.tsx'), 'BatchK8s'),
  JobExecutionLog: lazy(() => import('./containers/Batch/components/JobExecutionLog.tsx')),

  Mail: {
    Layout: lazyNamed(() => import('./containers/Mail/components/Layout.tsx'), 'Layout'),
    Console: lazyNamed(() => import('./containers/Mail/containers/Console/index.tsx'), 'Console'),
    SalesPromotions: lazyNamed(() => import('./containers/Mail/containers/SalesPromotions/index.tsx'), 'SalesPromotions'),
  },

  Notifications: {
    SystemNotificationsConfiguration: lazy(() => import('./containers/Notifications/pages/SystemNotificationsConfiguration/index.tsx')),
  },

  Localization: lazyNamed(() => import('./containers/Localization/index.tsx'), 'Localization'),

  Permalead: lazy(() => import('./containers/Permalead/index.tsx')),

  WebsiteMapping: lazyNamed(() => import('./containers/WebsiteMapping/index.tsx'), 'WebsiteMapping'),

  XandrCredentials: lazy(() => import('./containers/XandrCredentials/index.tsx')),
  XandrSegments: lazyNamed(() => import('./containers/XandrSegments/index.tsx'), 'XandrSegments'),
};

export default Administration;
